export var EventTrackType = /*#__PURE__*/ function(EventTrackType) {
    EventTrackType["Default"] = "Default";
    // Rely on playerCapabilities
    EventTrackType["CommonEventTrack"] = "CommonEventTrack";
    EventTrackType["VideoElementEventTrack"] = "VideoElementEventTrack";
    return EventTrackType;
}({});

//# sourceMappingURL=event-track.enums.js.map